
import dataUtil from '@/util/DataUtil'
import StorageService from '@/services/StorageService'
export default {
  namespaced: true,
  state: {
    groups: [
      {
        name: 'Admissions',
        items: [
          {
            name: 'Participants @',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          }
        ]
      },
      {
        name: 'Ads in program',
        items: []
      },
      {
        name: 'Exhibitors/vendors',
        items: [
          {
            name: 'Alibaba @',
            estimatedAmount: 18000,
            actualAmount: 18000,
            description: ''
          },
          {
            name: 'SG Innovate @',
            estimatedAmount: 15000,
            actualAmount: 15000,
            description: ''
          },
          {
            name: 'Small booths @',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          }
        ]
      },
      {
        name: 'Sale of items',
        items: []
      }
    ]
  },
  getters: {
    getGroups (state) {
      return state.groups
    },
    getTotal (state) {
      return dataUtil.getTotal(state.groups)
    }
  },
  mutations: {
    getGroups (state) {
      state.groups = []
    },
    addGroup (state, payload) {
      dataUtil.addGroup(state.groups, payload.itemName)
    },
    saveData (state) {
      StorageService.saveIncome(state.groups)
    },
    loadData (state) {
      let groups = StorageService.loadIncome()
      if (groups && groups.length > 0) {
        state.groups = groups
      }
    }
  },
  actions: {
    getGroups (context) {
      context.commit('getGroups')
    },
    addGroup (context, payload) {
      context.commit('addGroup', payload)
    },
    saveData (context) {
      context.commit('saveData')
    },
    loadData (context) {
      context.commit('loadData')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/IncomeModule.js